import { ButtonProps } from '~types'

export const createButton = (props: Omit<ButtonProps, 'id'> & { id?: string }): ButtonProps => ({
  color: 'light',
  fill: 'solid',
  size: 'md',
  isFullWidth: false,
  isTargetBlank: false,
  justify: 'left',
  modal: undefined,
  ...props,
  id: props.id || `btn-${Math.random().toString(36).substring(2, 9)}`
})
